import { Text } from '@mantine/core';
import { modals } from '@mantine/modals';
import type { TFunction } from 'i18next';

/**
 * 弹出"部分导出确认"对话框。
 * 用于配合 exportPaginatedData 的 onConfirmPartial 选项。
 */
export const confirmPartialExport = (t: TFunction, fetched: number, total: number) =>
  new Promise<boolean>((resolve) => {
    let confirmed = false;
    modals.openConfirmModal({
      title: t('chat_history.export.partial_title'),
      children: (
        <Text size="sm" style={{ whiteSpace: 'pre-line' }}>
          {t('chat_history.export.partial_message', { fetched, total })}
        </Text>
      ),
      labels: {
        confirm: t('chat_history.export.partial_confirm'),
        cancel: t('chat_history.export.partial_cancel'),
      },
      onConfirm: () => {
        confirmed = true;
      },
      onClose: () => resolve(confirmed),
    });
  });
